export class Fuel {
    public name: String;
    public isEnable: boolean;
    //
    constructor(name: String, isEnable: boolean) {
        this.name = name;
        this.isEnable = isEnable;
    }
}
